export const EXTRACT_PANEL_NAME = 'cut';
